export default function Marquee({ text }) {
  const content = text || "From the systems that run your business to the content your customers see, we build it all.";
  return (
    <section data-testid="marquee-banner" className="relative bg-navy border-y border-brand-blue/25 py-7 overflow-hidden">
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center" aria-hidden={k === 1}>
            <span className="font-display text-2xl sm:text-3xl font-semibold text-white/90 px-8">{content}</span>
            <span className="inline-block h-2.5 w-2.5 rounded-full bg-brand-cyan shadow-[0_0_16px_4px_rgba(56,189,248,0.6)] mx-4" />
          </div>
        ))}
      </div>
    </section>
  );
}
